module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Prologue#u7KEUZXGArsaYhCzOG9aZv7"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/OoM_001#uJHjfS3DPIsiDzCZD9cVPVG"
    }
  }, [_vm._v("CHARLES FREDERICK ALBRIGHT “The Eyeball Killer” 1+ KILLS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/OoM_002#uAgC9DnwNd4MeVuWQJ4lRc2"
    }
  }, [_vm._v("DAVID BERKOWITZ “Son of Sam” “.44-Caliber Killer” 6 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/OoM_003#udYgOh9fadslS6oSOhKUdZF"
    }
  }, [_vm._v("ANGELO BUONO & KENNETH BIANCHI “The Hillside Stranglers” 10 Kills/12 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/OoM_004#uPC9mAq57WlFuqDnbuD7MU9"
    }
  }, [_vm._v("LAWRENCE BITTAKER & ROY NORRIS “The Toolbox Killers” 5 Combined Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_005#ugcZnwheqzKEIH4iqaemGa9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DANIEL BLANK” River Parishes Serial Killer” 6 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_006#uoeWQ6GY4mYMsW72bY4DS88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILLIAM BONIN “Freeway Killer” 21+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_007#uyBzJF6aXQBRNwJhcjVu7k5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GARY RAY BOWLES “The I-95 Killer” 7 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_008#uymorgzw9OUCXIHzKxAkY87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JERRY BRUDOS “The Lust Killer” “Shoe Fetish Slayer” 4+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_009#uazwH6wheOK6VQb2YkuexUG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUDIAS BUENOANO “The Black Widow” 3+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_010#ufVLzuaEAtZ6gn2ZucOKMfC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TED BUNDY 36+ Kill")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_011#uzV6Irz6mIniF9xvlINpAO5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DAVID CARPENTER “The Trailside Killer” 10+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_012#utxt3TbLGFsInSRaUtLhTXD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEAN CARTER 5 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_013#u6PuDl4tSVAEKXttA5utBuB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DOUG CLARK 6 Kills (with CAROL BUNDY) 2+ Kills “Sunset Strip Killers”")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_014#upN3PPZx4fFt8ROkaLvYJW6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEAN CORLL “Candy Man” “Pied Piper” 28+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_015#ujzulU5YY6nrtGiDlGFrhFG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JUAN VALLEJO CORONA “The Machete Murderer” 25+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_016#u8bSB9j5pVXWiWWAfdC3YC5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLES CULLEN “Killer Nurse” 29+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_017#uTf5ox3rOJguL9kSi9D9vLG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JEFFREY DAHMER “Milwaukee Cannibal” 17 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_018#uhnVToaq35Xwz3sfU5ZASrE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JAMES DAVEGGIO & MICHELLE MICHAUD 4+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_019#ubeWcOcVuxohP3rzCZCETW8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PAUL DUROUSSEAU “The Jacksonville, FL Serial Killer” 7+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_020#uJ88rftoQZWkjriMlBUM8k9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WAYNE FORD 4-6 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_021#uJrxyyFgKvGhDdD2kalBGu7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KENDALL FRANCOIS 8 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_022#urSbEwfKq3ktWoEvv73mbvD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOHN WAYNE GACY “Killer Clown” 33-35 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_023#uKHs4ZUUmt8GrU2aP9RkIo3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GERALD ARMOND GALLEGO Jr. and CHARLENE ADELLE WILLIAMS GALLEGO “The Sex Slave Murders” 10 Kills and 1 Fetus")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_024#u9AIATBEShYoYiXw8nhr3aC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ED GEIN 2+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_025#uJyNAfUS8wRjabIfJNEuKa7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KRISTEN GILBERT “Angel of Death” 40-100+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_026#uH8c8pG97dM8D8xyIFPAXQA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LORENZO GILYARD “The Kansas City Strangler 13+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_027#uU6iwtAzLIl5qxvu3xHAMtB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DAVID GORE and FRED WATERFIELD “Killing Cousins” 6 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_028#uxYppm5Ov6n87O6jTLTX2x6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROBERT HANSEN “Butcher Baker” 17-30 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_029#uYEFUOlKpIvDMb8qgOzAnPG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILLIAM GEORGE HEIRENS “The Lipstick Killer” 3 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_030#u4XuorEkLixESe4rM3indf2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KEITH JESPERSON “Happy Face Killer” 8+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_031#uTeq3IgBnX3V5hh9ZdGEPrB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VINCENT JOHNSON “The Brooklyn Strangler” “The Williamsburg Strangler” 5+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_032#ulPd67HZnWNDXfQu3ke34iD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GENENE JONES “Angel of Death” 11-60 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_033#unLHj4Dfs9UAyZjH2rDvQUC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PATRICK KEARNEY “The Freeway Killer” “Trash Bag Murderer” 21-43 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_034#uqhNdCbxyRsv4B2xEIGs6qE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EDMUND KEMPER “Co-Ed Killer” “Co-Ed Butcher” 10 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_035#uKCkCnAXDoIf5c455Ltxm4F",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANTHONY KIRKLAND 5 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_036#uXrKhunRQtLoVmegj59CWP5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RANDY KRAFT “Scorecard Killer” “The Freeway Killer” 37-62+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_037#uoDwZf2ycwYHEOCOFUIV7w8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TIMOTHY KRAJCIR 9 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_038#uyWkISnCzzZXb3k9J3EXD9F",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REX KREBS 2 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_039#ubhXZtnLiitAhv9cLd5aDJC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHARLES NG and LEONARD LAKE 13-25 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_040#uS5yUJfliJFatrkSpvCE6EC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DERRICK LEE “The Baton Rouge Serial Killer” 7-19 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_041#uWGKrtDkfnrZpxM2dtvbqC7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BOBBY JOE LONG \"The Classified Ad Rapist” 10 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_042#ul5NiJq6ezB4PfWn8gqnfo5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HENRY LEE LUCAS “The Confession Killer” 11-50+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_043#uosp2MMucAli2AcFsSwhIh5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DICK MARQUETTE 3 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_044#ustxVztye8tiYcrrdUlf7AC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLANCHE MOORE “Black Widow” 4 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_045#ul4yKBJsjoaWQQDsgudGh8D",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HERB MULLIN 13 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_046#uD9qsoKYHuMj9zwkxSyw677",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILLIAM LEE CODY NEAL 3 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_047#u4ypzq64WqdRcl4fNgWi5g9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILLIE PICKTON “The Pig Farmer Killer” 60+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_048#uZS43LfCakqNULO8XIPJpID",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DOROTHEA PUENTE “Death House Landlady” 9+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_049#ux4brbCjF6unlCov2fGae55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DENNIS RADER “The BTK Killer” 10+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_050#uFtwMj8jjtUYWYI5rlxBqYE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RICHARD RAMIREZ “The Night Stalker” 14 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_051#uGrgsbRClk8m4t6h7E7UMVE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROBERT RELDAN “The Charmer” 2 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_052#upmnUNmKi5pcOKmb5C8Rxu2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GARY RIDGWAY “The Green River Killer” 71-90+")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_053#uzEQZTEANYy3PJ4bYzy8Sk5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOEL RIFKIN 17 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_054#u6o2maaBLjFvyGB5GPwZJGD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DANNY ROLLING “Gainesville Ripper 8 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_055#uDb8qFF2As92SCSf85SPmiC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TOMMY LYNN SELLS “The Cross Country Killer 22+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_056#uxRrKQCblkefDmQHB3pqLT7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PAULA SIMS 2 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_057#uAsvZw4SzVhMsiPIwhA5yOA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JEREMY & JAMIE SLY: KILLER TWINS:")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_058#uxlVUaWrHvM5o5N5SwqOsEG",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRUCE & STEPHEN SPAHALSKI: KILLER TWINS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_059#ulcGuYV9IWKXuHlIIhcKjY8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TIMOTHY SPENCER “Southside Strangler” 5 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_060#uZiuaFcFUBb4sUjCaMeXNeE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("STEPHEN STANKO 2 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_061#ukNIkZHQsyHTq3wwgvELNbD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WILLIAM SUFF “Riverside CA Prostitute Killer” “Lake Elsinore Killer” 15-22 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_062#uNHjRoK3Mup7PBNy8Lrl3z5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARYBETH TINNING 8 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_063#uvb54V5heTlYpPIzIhrpyXA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OTTIS TOOLE 6+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_064#uxIZdsWvv6AtJltOOC4EvE3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOE TURE 6+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_065#uqF9ssvelGuuALoBzTzhpS2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHESTER TURNER 15+ Kills and 1 fetus")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_066#udzJyCMck2ZCAaoty8pSRpE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CORAL WATTS “The Sunday Morning Slasher” 80+ Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/OoM_067#uwAGefqqbFApmlhoKS5zVc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AILEEN WUORNOS 7 Kills")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/TheDeathPenalty#ulv9gTVilBXCSV2iROsYah4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE DEATH PENALTY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Bibliography#uEppdwNsHkVyB5HqzaWvLb2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea93f88a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 69
// module chunks = 0